import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getArtistStats, updateFormData } from '../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";

const RandomActionsButton = ({ count = 3, queriesEnabled = true }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [load, setLoad] = useState(false);
    const [randomActions, setRandomActions] = useState([]);
    const { artistStats } = useSelector(state => state?.artistDetails);

    const getRandomActions = (arr, num) => {
        const shuffled = [...arr].sort(() => 0.5 - Math.random());
        return shuffled.slice(0, num);
    };

    useEffect(() => {
        if (!queriesEnabled) return;
        dispatch(getArtistStats(toast, { type: 'all' }, setLoad));
    }, [dispatch, queriesEnabled]);

    useEffect(() => {
        if (!queriesEnabled) return;
        if (!artistStats?.topTrackData?.track_name) return;

        const actionItems = [
            {
                id: 1,
                label: "Run Streams Conversion",
                description: `'${artistStats?.topTrackData?.track_name}' is trending up; consider promoting it further.`,
                route: "/admin/growth-engine/campaign",
            },
            {
                id: 2,
                label: "Grow your own Playlist",
                description: "Take Control of your promotional needs.",
                route: "/admin/growth-engine/campaign",
            },
            {
                id: 3,
                label: "Run a Pre-Save Campaign",
                description: "Get fans to pre-save this release and every release going forward.",
                route: "/admin/growth-engine/campaign",
            },
            {
                id: 4,
                label: "Run Conversion Campaign",
                description: `'${artistStats?.topTrackData?.track_name}' is trending up; consider promoting it further.`,
                route: "/admin/growth-engine/campaign",
            },
            {
                id: 5,
                label: "Create a Music Link",
                description: "Get your music heard by fans of your genre.",
                route: "/admin/artist-manager/build-music-link",
            },
            {
                id: 6,
                label: "Master a Track",
                description: "Improve Sound Quality with your AI Engineer.",
                route: "/admin/audio-engineer",
            },
        ];

        setRandomActions(getRandomActions(actionItems, count));
    }, [artistStats?.topTrackData?.track_name, count, queriesEnabled]);

    const handleClickInsights = (value) => {
        const updateData = {
            objective: value === "Grow your own Playlist" ? "Playlist Growth" : "Pre-Save Link",
            callToAction: value === "Grow your own Playlist" ? "Listen Now" : "Book Now",
            platformType: '',
            shouldShowFeatureFM: value === "Grow your own Playlist",
        };
        dispatch(updateFormData(updateData));
    };

    const handleNavigation = (route, label) => {
        handleClickInsights(label);
        navigate(route);
    };

    return (
        <div className="space-y-3">
            {randomActions.map((action) => (
                <div
                    key={action.id}
                    className="p-4 hover:shadow-md transition-shadow"
                >
                    <div className="flex items-start gap-3">
                        <div className="flex-1 min-w-0">
                            <div className="text-center">
                                <p className='text-sm font-bold mb-2'>{action.description}</p>
                                <button
                                    type='button'
                                    onClick={() => handleNavigation(action.route, action.label)}
                                    className='btn-custom3 w-full !py-3'
                                >
                                    {action.label}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default RandomActionsButton;